import { __assign } from "tslib";
import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import UnknownFullView from './Unknown';
import ImageFullView from './Image';
import FilmFullView from './Film';
import FlashFullView from './Flash';
import JournalFullView from './Journal';
import LiteratureFullView from './Literature';
import MotionbookFullView from './Motionbook';
import PdfFullView from './Pdf';
import PollFullView from './Poll';
import StatusFullView from './Status';
import CommissionFullView from './Commission';
import HiddenFullView from './Hidden';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
var DeviationFullView = function (props) {
    var _a = useDeviationMatureFilter(props.deviation), showBlocked = _a.showBlocked, overrideMatureFilter = _a.overrideMatureFilter;
    if (showBlocked) {
        return (React.createElement(HiddenFullView, __assign({ overrideMatureFilter: overrideMatureFilter }, props)));
    }
    var deviationType = getDeviationType(props.deviation);
    switch (deviationType) {
        case DeviationTypes.IMAGE:
            return React.createElement(ImageFullView, __assign({}, props));
        case DeviationTypes.FILM:
            return React.createElement(FilmFullView, __assign({}, props));
        case DeviationTypes.PDF:
            return React.createElement(PdfFullView, __assign({}, props));
        case DeviationTypes.MOTIONBOOK:
            return React.createElement(MotionbookFullView, __assign({}, props));
        case DeviationTypes.FLASH:
            return React.createElement(FlashFullView, __assign({}, props));
        case DeviationTypes.LITERATURE:
            return React.createElement(LiteratureFullView, __assign({}, props));
        case DeviationTypes.JOURNAL:
            return React.createElement(JournalFullView, __assign({}, props));
        case DeviationTypes.STATUS:
            return React.createElement(StatusFullView, __assign({}, props));
        case DeviationTypes.POLL:
            return React.createElement(PollFullView, __assign({}, props));
        case DeviationTypes.COMMISSION:
            return React.createElement(CommissionFullView, __assign({}, props));
        default:
            return React.createElement(UnknownFullView, __assign({}, props, { type: deviationType }));
    }
};
export default DeviationFullView;
//# sourceMappingURL=Full.js.map